module.exports = __webpack_public_path__ + "img/thirteenimg2.84b62663.png";